import Reveal from '@/components/base/Reveal';
import { hotRanking } from '@/mocks/home';

function HotRanking() {
  return (
    <section id="hot" className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
            <div>
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-primary-600 font-label">
                <i className="ri-fire-fill"></i>
                HOT RANKING
              </span>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                今日热度榜
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
                按 24 小时内的阅读与讨论量排序，热度越高，说明关注与争议越集中。
              </p>
            </div>
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              数据统计至 今日 09:00
            </p>
          </div>
        </Reveal>

        <div className="mt-10 md:mt-14 border-t border-background-200">
          {hotRanking.map((item, index) => (
            <Reveal key={item.rank} delay={index * 70}>
              <a
                href="#latest"
                className="group flex flex-col md:flex-row md:items-center gap-3 md:gap-6 py-6 md:py-7 border-b border-background-200 hover:bg-background-100/70 transition-colors px-2 md:px-4 cursor-pointer"
              >
                <span
                  className={`font-heading text-3xl md:text-4xl font-bold w-12 md:w-16 shrink-0 ${
                    item.rank === 1
                      ? 'text-primary-600'
                      : item.rank <= 3
                        ? 'text-foreground-900'
                        : 'text-foreground-400'
                  }`}
                >
                  {String(item.rank).padStart(2, '0')}
                </span>

                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                </div>

                <div className="flex items-center gap-4 shrink-0">
                  <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="flex items-center gap-1 text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.heat}
                  </span>
                  <span
                    className={`flex items-center text-xs whitespace-nowrap ${
                      item.trend === 'up' ? 'text-primary-600' : 'text-foreground-400'
                    }`}
                  >
                    <i
                      className={
                        item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'
                      }
                    ></i>
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HotRanking;